import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { styled } from '@mui/material';
import ApprovalNoticeBox from '@/components/Approval/@components/ApprovalNoticeBox';
import { VehicleCostSnapshot } from '@/components/Approval/@components/VehicleCost';
import { VEHICLE_COST_HR_MISSING_MESSAGE } from '@/utils/approval/vehicleCost';
import { FieldBlock } from './styles';
import type { ApprovalFormValues } from './types';

const HrMissingNotice = styled(ApprovalNoticeBox)`
  color: var(--dk-danger, #f55060);
`;

/** 차량유지비 신청(93) 임직원 정보 — 저장될 content 를 그대로 보여 줌 */
const VehicleCostField = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<ApprovalFormValues>();
  const content = useWatch({ control, name: 'vehicleCostContent' });

  return (
    <FieldBlock>
      {content ? (
        <VehicleCostSnapshot content={content} />
      ) : (
        <HrMissingNotice>{t(VEHICLE_COST_HR_MISSING_MESSAGE)}</HrMissingNotice>
      )}
    </FieldBlock>
  );
};

export default VehicleCostField;
